import { client } from 'laravel-precognition-vue'

export const updateToken = (token: string) => {
  client.axios().defaults.headers.common['Authorization'] = `Bearer ${token}`
}
